import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const TareaDetalleGestionarClienteDisconforme = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleGestionarClienteDesconforme/tarea-detalle-gestionar-cliente-desconforme"
    )
);
const ErrorPage = React.lazy(() => import("../components/error-page"));
export function tareaDetalleAprobarServiceRequest() {
  return (
    <Route
      path="/tarea-detalle-aprobar-service-request"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleGestionarClienteDisconforme />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
